<template>
  <el-dialog
    :title="title"
    width="760px"
    append-to-body
    custom-class="discard-dialog"
    :visible.sync="discardVisible"
    :before-close="handleCancelDiscard"
  >
    <el-form :model="infoForm" ref="infoForm" v-if="rejectType == 'discard'">
      <el-form-item
        label="原因类型："
        :required="true"
        :show-message="false"
        prop="deprecate_reason_type"
      >
        <el-radio-group v-model="infoForm.deprecate_reason_type">
          <el-radio :label="0">其他</el-radio>
          <el-radio :label="1">重复</el-radio>
          <el-radio :label="2">版权</el-radio>
          <el-radio :label="3">链接失效</el-radio>
          <el-radio :label="4">非主流</el-radio>
          <el-radio :label="5">翻译</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div v-if="rejectType == 'reject'" class="mb-12">
      <div class="checkboxTitle ml-8 mb-8">规范性问题：</div>
      <el-checkbox-group
        size="mini"
        v-model="deprecate_reason_type"
        class="ml-12"
      >
        <el-checkbox
          class="checkboxItem mb-8 ml-8"
          v-for="item in normativeProblems"
          :label="item.value"
          :key="item.value"
          >{{ item.name }}</el-checkbox
        >
      </el-checkbox-group>
    </div>
    <div v-if="rejectType == 'pro_reject'">
      <div class="problem_container mb-12">
        <div class="checkboxTitle ml-8 mb-8">规范性问题：</div>
        <el-checkbox-group
          size="mini"
          v-model="deprecate_reason_type"
          class="ml-12"
        >
          <el-checkbox
            class="checkboxItem mb-8 ml-8"
            v-for="item in normativeProblems"
            :label="item.value"
            :key="item.value"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <el-divider direction="horizontal"></el-divider>
      <div class="problem_container mb-12">
        <div class="checkboxTitle ml-8 mb-8">专业性问题：</div>
        <el-checkbox-group
          size="mini"
          v-model="deprecate_reason_type"
          class="ml-12"
        >
          <el-checkbox
            class="checkboxItem mb-8 ml-8"
            v-for="item in professionalProblems"
            :label="item.value"
            :key="item.value"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
    <MarkDown
      :value.sync="reason"
      defaultOpen="edit"
      placeholder="请填写拒绝/驳回/废弃原因(必填)..."
      space="_for_skill_sub_project"
      folder="admin"
    ></MarkDown>
    <template v-slot:footer>
      <div class="button-footer">
        <div></div>
        <div>
          <el-button
            :loading="btnLoading"
            @click="handleCancelDiscard"
            class="discard-btn"
            size="mini"
            >取消</el-button
          >
          <el-button
            :loading="btnLoading"
            @click="handleDiscard"
            class="discard-btn"
            type="danger"
            size="mini"
            >确定</el-button
          >
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import skillService from "@/global/service/skill";
import { mapState } from "vuex";
import MarkDown from "@/components/Markdown.vue";
export default {
  components: {
    MarkDown
  },
  props: {
    discardVisible: {
      default: false,
      type: Boolean
    },
    currentId: {
      type: Number
    },
    rejectType: {
      type: String,
      default: "reject"
    },
    title: {
      type: String,
      default: ""
    },
    spendTime: {
      type: Number,
      default: 0
    },
    countdownTime: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      btnLoading: false,
      reason: "",
      infoForm: {
        deprecate_reason_type: 0
      },
      deprecate_reason_type: [],
      normativeProblems: [
        {
          name: "语句不通/错别字/有超链接/图片不清晰有水印",
          value: 201
        },
        {
          name: "专有名词书写不规范",
          value: 202
        },
        {
          name: "选项不合理/序号/方向指引/都对(错)",
          value: 203
        },
        {
          name: "类别错误",
          value: 204
        },
        {
          name: "答题时长不合理",
          value: 205
        }
      ],
      professionalProblems: [
        {
          name: "时效性/版本依赖问题",
          value: 301
        },
        {
          name: "题干有歧义",
          value: 302
        },
        {
          name: "过于简单/无意义/未考察核心知识点",
          value: 303
        },
        {
          name: "代码格式不规范/无法运行/多余转义符",
          value: 304
        },
        {
          name: "选项不合理/干扰项无意义/答案明显二选一",
          value: 305
        },
        {
          name: "答案错误",
          value: 306
        },
        {
          name: "解析不合理/不完善/无意义",
          value: 307
        },
        {
          name: "难度不合理",
          value: 308
        },
        {
          name: "存在相似题目",
          value: 309
        }
      ]
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  methods: {
    handleCancelDiscard() {
      if (this.btnLoading) return;
      this.reason = "";
      this.infoForm.deprecate_reason_type = 0;
      this.$emit("update:discardVisible", false);
    },
    async handleDiscard() {
      const id = this.currentId;
      if (this.btnLoading) return;
      if (this.reason.length > 200) {
        this.$message.error("原因请不要超过200字!");
        return;
      }
      if (this.reason && this.deprecate_reason_type.length) {
        let service = (service = skillService.skillQuestionReviewTaskTypeQuestionReject(
          this.rejectType === "reject" ? 1 : 2,
          id,
          {
            reason: this.reason,
            deprecate_reason_type: String(this.deprecate_reason_type),
            spend_time: this.spendTime,
            countdown_time: this.countdownTime
          }
        ));
        this.btnLoading = true;
        service
          .then(res => {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.$emit("updateStatus", { id, status: res.status });
            this.reason = "";
            this.infoForm.deprecate_reason_type = 0;
            this.deprecate_reason_type = [];
            this.$emit("update:discardVisible", false);
          })
          .finally(() => {
            this.btnLoading = false;
          });
      } else {
        this.$message({
          type: "error",
          message: "请填写原因并且选择相关问题!"
        });
        return;
      }
    }
  }
};
</script>

<style lang="less">
.discard-dialog {
  .el-textarea .el-input__count {
    bottom: 5px !important;
  }
}
</style>
<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 8px 24px !important;
}
/deep/ .el-divider--horizontal {
  margin: 12px 0 !important;
}
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/deep/.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

/deep/.el-dialog__body {
  padding: 8px 24px !important;
}
.button-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.checkboxTitle {
  font-size: 15px;
  // font-weight: bold;
  color: #303133;
}
.checkboxItem {
  width: 300px;
}
</style>
